import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {

  @Input() data: any;
  @Output() changePage = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  changePG(e: any) {
    if (e.label != this.data.current_page) {
      this.changePage.emit(e.url);
    }
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

}
